import React, { Component } from "react";
import { sanitizeParams } from "wvus-sponsorship-engine";
import sanitizeHtml from "sanitize-html-react";

(function() {
  // Check And Set campaign querystring parameter to the window object as cache
  try {
    const campaignParamRE = /[&?]campaign=(\d{7,})/i;
    const campaignParameter = (campaignParamRE.exec(window.location.search)||[])[1];
    setCampaignQSParameterCache(campaignParameter);
  } catch (err) {
    return;
  }
}());

export function getWindowObject() {
  return typeof window !== "undefined" ? window : {};
}

export function getAppSettings() {
  // Check The Window Object To Get The App Settings
  const windowObject = getWindowObject();
  return windowObject.wv_rcds && windowObject.wv_rcds.settings;
}

export function setCampaignQSParameterCache(campaignParameter) {
  if (typeof window !== "undefined" && window.wv_rcds && window.wv_rcds.settings && campaignParameter) {
    window.wv_rcds.settings.cacheCampaignParameter = campaignParameter;
  }
}

export function getCampaignQSParameterCache() {
  try {
    return window.wv_rcds.settings.cacheCampaignParameter || "";
  } catch (err) {
    return "";
  }
}

export function getCampaignConfig() {
  const settings = getAppSettings();
  return settings.campaignCode;
}

export function getHonorCampaignQSConfig() {
  const settings = getAppSettings();
  return settings.honorCampaignCodeQS || false;
}

export function getCampaignQueryString() {
  try {
    const windowObject = getWindowObject();
    let campaignParam = getCampaignQSParameterCache();

    if (!campaignParam) {
      // Try Checking Again
      const campaignParamRE = /[&?]campaign=(\d{7,})/i;
      campaignParam = (campaignParamRE.exec(windowObject.location.search)||[])[1];
      setCampaignQSParameterCache(campaignParam);
    }

    return campaignParam;
  } catch (err) {
    return "";
  }
}

export function appendCampaignToUrl(url, campaign = "") {
  if (!campaign || !url) {
    return url;
  }

  try {
    const urlPattern = /^([^?]+)(\?[^#]*)?(#.*)?$/;
    const [_, urlPath, query="?", hash=""] = urlPattern.exec(url);
    const queryWithCampaign = query.replace(/[&?]campaign=[^=&#]+/i, "") + (`&campaign=${campaign}`);
    const urlWithCampaign = [urlPath, queryWithCampaign, hash].join("");
  
    return urlWithCampaign;
  } catch (err) {
    return url;
  }
}

export function appendCampaignDefaultToUrl(url) {
  const campaignDefault = getCampaignConfig();
  const campaignParam = getCampaignQueryString();
  const honorCampaignQS = getHonorCampaignQSConfig();
  const honorCampaignParams = honorCampaignQS === true && campaignParam;

  // Query Parameter Then Leave As Is
  if (honorCampaignParams || !campaignDefault || !url) {
    return url;
  }

  return appendCampaignToUrl(url, campaignDefault);
}

export function getSearchDefaultParams() {
  const settings = getAppSettings();
  const defaultParams = settings.searchDefault;
  return defaultParams && sanitizeParams(defaultParams, "searchTerm") || {};
}

export function mergeSearchDefaultParams(params = {}) {
  const defaultSearchParms = getSearchDefaultParams();
  const overrideSearchParams = sanitizeParams(params, "searchTerm");

  // Use Object Assign To Overwrite The Defaults
  return Object.assign({}, defaultSearchParms, overrideSearchParams);
}

// Allow only a super restricted set of tags and attributes
export function cleanHtml(dirty) {
  return sanitizeHtml(dirty, {
    allowedTags: ["b", "i", "em", "strong", "a", "p", "img", "h2", "h3", "li", "ul", "br"],
    allowedAttributes: {
      a: ["href", "class"],
      img: ["src", "class"],
      p: ["class"],
    },
    transformTags: {
      img: function(tagName, attribs) {
        if (!attribs.src.startsWith("https://wvusstatic.com")) {
          attribsSrc = "";
        }
        return {
          tagName: "img",
          attribs: {
            src: "",
            class: "clean-image",
          },
        };
      },
    },
  });
}

export function getErrorMessage(){
  const windowObject = getWindowObject();
  console.log(windowObject);
  if(windowObject.wv_rcds.settings.hasOwnProperty('errorMessage')){
   return <React.Fragment><span dangerouslySetInnerHTML={{ __html: cleanHtml(windowObject.wv_rcds.settings.errorMessage) }}></span></React.Fragment>;
  }
  return (
    
    <React.Fragment>Sorry, something went wrong. Would you mind trying again? If that doesn't help, give us a call at <a href="tel:8008312255">1.800.831.2255</a> so we can help</React.Fragment>
    );
}

